export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9027.a8887c9c.jpg";